import { mapRange, distance as distance2Points, quadInOut } from '@wix/wow-utils';
import { getCssUnits, getMouseTransitionEasing } from '../../utils';
import { CustomMouse } from './CustomMouse';
const paramsMap = {
  soft: {
    angle: 0,
    scale: 1,
    easing: 'easeOut'
  },
  medium: {
    angle: 25,
    scale: 0.7,
    easing: 'easeOut'
  },
  hard: {
    angle: 65,
    scale: 0.25,
    easing: 'easeOut'
  }
};
class BlurMouseAnimation extends CustomMouse {
  progress(_ref) {
    let {
      x: progressX,
      y: progressY
    } = _ref;
    const {
      distance,
      angle,
      scale,
      invert,
      blur,
      perspective
    } = this.options;
    const translateX = mapRange(0, 1, -distance.value, distance.value, progressX) * invert;
    const translateY = mapRange(0, 1, -distance.value, distance.value, progressY) * invert;

    // if progressX === 0 || progressX === 1, scaleX === scale, if progressX === 0.5, scaleX === 1
    const scaleX = progressX < 0.5 ? mapRange(0, 0.5, scale, 1, progressX) : mapRange(0.5, 1, 1, scale, progressX);

    // if progressY === 0 || progressY === 1, scaleY === scale, if progressY === 0.5, scaleY === 1
    const scaleY = progressY < 0.5 ? mapRange(0, 0.5, scale, 1, progressY) : mapRange(0.5, 1, 1, scale, progressY);
    const maxScale = Math.min(scaleX, scaleY);

    // if progressX === 0, rotateX === -angle, if progressX === 0.5, rotateX === 0, if progressX === 1, rotateX === angle
    const rotateX = mapRange(0, 1, -angle, angle, progressY) * invert;
    const rotateY = mapRange(0, 1, angle, -angle, progressX) * invert;
    const units = getCssUnits(distance.type);
    const transform = `perspective(${perspective}px) translateX(${translateX}${units}) translateY(${translateY}${units}) scale(${maxScale}, ${maxScale}) rotateX(${rotateX}deg) rotateY(${rotateY}deg) rotate(var(--comp-rotate-z, 0deg))`;
    const progressDistance = distance2Points([0.5, 0.5], [progressX, progressY]);
    const blurFilter = Math.round(mapRange(0, 1, 0, blur, quadInOut(progressDistance)));
    const filter = `blur(${blurFilter}px)`;
    this.target.style.transform = transform;
    this.target.style.filter = filter;
  }
  cancel() {
    this.target.style.transform = '';
    this.target.style.filter = '';
    this.target.style.transition = '';
  }
}
export default function create(options) {
  const {
    transitionDuration,
    transitionEasing
  } = options;
  const {
    power,
    inverted = false,
    distance = {
      value: 80,
      type: 'px'
    },
    angle = 5,
    scale = 0.3,
    blur = 20,
    perspective = 600
  } = options.namedEffect;
  const invert = inverted ? -1 : 1;
  const animationOptions = {
    transition: transitionDuration ? `transform ${transitionDuration}ms ${getMouseTransitionEasing(power ? paramsMap[power].easing : transitionEasing)}, filter ${transitionDuration}ms ${getMouseTransitionEasing(power ? paramsMap[power].easing : transitionEasing)}` : '',
    distance,
    angle: power ? paramsMap[power].angle : angle,
    scale: power ? paramsMap[power].scale : scale,
    blur,
    perspective,
    invert
  };
  return target => new BlurMouseAnimation(target, animationOptions);
}
//# sourceMappingURL=BlurMouse.js.map